import service from '@/services/admin/user'
import { Session } from '@/plugins/session'

const getDefaultState = () => ({
  session: null,
  user: {
    username: '',
    email: '',
    waTelefonos: '',
    password: '',
    fullname: '',
    state: true,

    roles: [],
    crmRole: 'NO APLICA'
  },
  list: [],
  profileChecked: false,
  currentRow: null,
  saved: null
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.user = getDefaultState().user),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_USER: (state, obj) => {
    state.user = obj
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.list = obj
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  SET_DEFAULT_ROLES: (state, roles) => {
    const defaultRoles = roles.map(r => ({ ...r, check: false }))

    state.user.roles = state.user.roles.length
      ? [...state.user.roles, ...defaultRoles.filter(e => !state.user.roles.find(r => r.name === e.name))]
      : defaultRoles
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.user = obj
    state.saved = false
  },
  PROFILE_CHECKED: state => {
    state.profileChecked = true
  }
}

export const actions = {
  create: ({ commit }, item) => service.create(item),

  getLatestVersion: () => service.getLatestVersion(),

  createUser: async ({ commit, rootGetters }, input) => {
    delete input.createdAt
    delete input.updatedAt
    if (input._id) {
      input.id = input._id // FIXME: esto es una solución temporal para que el id sea el mismo que el _id
    }

    return service.createUser(input, await rootGetters['facturacion/emisorStore/get_Id']).then(result => commit('UPDATE_LIST', { ...input, _id: result._id }))
  },

  createSystemUser: async ({ commit, rootGetters }, input) => {
    // if (input._id) {
    //   input.id = input._id // FIXME: esto es una solución temporal para que el id sea el mismo que el _id
    // }

    return service.createSystemUser(input, await rootGetters['facturacion/emisorStore/get_Id'])
    // .then(result => commit('UPDATE_LIST', { ...input, _id: result._id }))
  },

  changeSubUserPassword: async ({ rootGetters }, input) =>
    service.changeSubUserPassword({ ...input, emisor: await rootGetters['facturacion/emisorStore/get_Id'] }),

  changePassword: async (_, input) => service.changePassword(input),

  changeProfile: async ({ _ }, profile) => {
    return service.changeProfile(Session.user.id, profile)
  },

  authentication: ({ commit /* , dispatch */ }, { credentials, setLocalToken }) => service.authentication(credentials, setLocalToken),

  checkreCaptchaAndEmail: ({ commit }, item) =>
    service.checkreCaptchaAndEmail(item.reCaptcha || null, item.email).then(result => {
      if (result) {
        delete item.reCaptcha
        // commit('SET_USER', item)

        return result
      }

      return false
    }),

  clearAll({ commit }) {
    Session.end()
    commit('RESET_STATE')

    commit('admin/roleStore/RESET_STATE', null, { root: true })

    commit('facturacion/emisorStore/RESET_STATE', null, { root: true })
    commit('facturacion/receptorStore/RESET_STATE', null, { root: true })
    commit('facturacion/facturaStore/RESET_STATE', null, { root: true })
    commit('facturacion/mensajeReceptorStore/RESET_STATE', null, { root: true })

    commit('compras/comprasStore/RESET_STATE', null, { root: true })
    commit('inventario/descuentoStore/RESET_STATE', null, { root: true })
    commit('inventario/facturaCompraStore/RESET_STATE', null, { root: true })
    commit('inventario/itemStore/RESET_STATE', null, { root: true })
    commit('inventario/proveedorStore/RESET_STATE', null, { root: true })

    commit('cliente/categoriaStore/RESET_STATE', null, { root: true })
    commit('cliente/clienteStore/RESET_STATE', null, { root: true })
    commit('cliente/cronStore/RESET_STATE', null, { root: true })

    commit('produccion/orderStore/RESET_STATE', null, { root: true })
    commit('produccion/productionStore/RESET_STATE', null, { root: true })

    return true
  },

  healthCheck: () => service.healthCheck(),
  resetList: ({ state }) => {
    state.list = []
  },

  readAllByEmisor: async ({ commit, state, rootGetters, dispatch }, { restart = false }) => {
    if (restart) await dispatch('resetList')

    if (state.list.length) {
      console.log('List Users form cache ⏩')
      return state.list
    }

    return service.readAllByEmisor(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      console.log('List Users form DB 🥲')

      commit('SET_LIST', response)
      return response
    })
  },

  readSubUserById: async ({ commit }, _id) => service.readSubUserById(_id).then(response => commit('SET_USER', response)),

  setDomain: async ({ rootGetters }, input) => service.setDomain(input, await rootGetters['facturacion/emisorStore/get_Id']),

  recupera: async (_, { reCaptcha, email }) => service.recupera(reCaptcha, email),
  recuperaPassword: async (_, { reCaptcha, password, hash }) => service.recuperaPassword(reCaptcha, password, hash),

  delete: async ({ commit, rootGetters }, items) =>
    service.delete(items, await rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    }),

  checkProfile: async ({ commit, state, rootGetters }) => {
    // evita consultar el perfil en cada opción del menu. Lo debe hacer solo la primer vez cuando entra a la app.
    if (state.profileChecked) return true

    return service.checkProfile(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      commit('PROFILE_CHECKED')

      if (new Date(response.subscriptionTimeOut) < Date.now()) {
        let subsDate = new Date(response.subscriptionTimeOut)
        subsDate.setDate(subsDate.getDate() + 3)

        if (subsDate > Date.now()) {
          console.log('suscripcion en periodo de gracia 🤨')
          Session.setSubscription(true, true, response.subscriptionTimeOut)
        } else {
          console.log('suscripcion vencida 📛')
          Session.setSubscription(false)
        }
      } else {
        console.log('suscripcion activa ✅')
        Session.setSubscription(true)
      }
    })
  },
  setProfile: ({ commit /* , dispatch */ }, { type, method, card, amount }) => service.setProfile(Session.user.id, type, method, card, amount),

  getPaymenntMethod: ({ commit /* , dispatch */ }) => service.getPaymenntMethod(Session.user.id),
  refreshToken: ({ _ }, email) => service.refreshToken(email)
}

export const getters = {
  getUserId: state => state.user.id
}
